'use strict';

module.exports = {
    // Liczba żyć.
    up: 0,

    // Procent życia.
    hp: 100,

    // Liczba doświadczenia.
    exp: 0,

    // Poziom. Max = 100.
    lvl: 1
};
